import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

// Shown when the backend returns 409 APPROVAL_REQUIRED. The maker's proposed values are
// preserved by the caller; clicking Submit sends them to the approval engine.
export function ApprovalRequiredModal({ open, onOpenChange, onSubmit, busy, entity = "change", testid = "approval-required-modal" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-amber-600" /> Owner approval required</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">
          This {entity} requires Owner approval before it can be applied. Your edits are preserved and
          will be sent for review — the record stays unchanged until an owner approves.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="approval-required-cancel">Cancel</Button>
          <Button onClick={onSubmit} disabled={busy} data-testid="approval-required-submit" className="bg-slate-900 text-white">
            {busy ? "Submitting…" : "Submit for Approval"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
